import React, { Component } from "react";

class TerrainAmenities extends Component{

    constructor(props){
        super(props)
        this.fa_icon_map = {"HotTub":"et-icon-help","Spa":"et-icon-help","Swimming_pool":"et-icon-help","Free_Wifi":"et-icon-help","Free_Parking":"et-icon-help","Bath_Tub":"et-icon-help","24_Hrs Fitness":"et-icon-help","Restaurants":"et-icon-help","Key_Card Access":"et-icon-help","Non_Smoking":"et-icon-help","Elevator":"et-icon-help","Shuttle_Service":"et-icon-help","Snorkling_Service":"et-icon-help","Laundry":"et-icon-help"}
    }
    render(){
        const ars = [];
        console.log('############### this.props.amenities')
        console.log(this.props.amenities)

        const ar = this.props.amenities
        let icon_map = {}

        // /^\s*$/g
        const regex_space = /^\s*$/g
        if(ar && ar.length > 0){

            ar.forEach( (s, idx)=>{
                let k = s.replace(' ', '_')
            
               //let k = s.replace(regex_space, '_')
                icon_map[k] = 'et-icon-help'
            })
            console.log('############### icon_map')
            console.log(JSON.stringify(icon_map))
        }
      


       
        const sv_ams_li = this.props.amenities.map((l, k)=>{
            console.log("##################am name:", l)
            const icon_key = l.replace(' ', '_')
            let  fa_icon = this.fa_icon_map[icon_key]
            fa_icon = fa_icon ? fa_icon :  'et-icon-zoom-in'
            let fa_cls_list = "text-muted dropdown-toggle " + fa_icon
            return ( <li> <a href="javascript:void(0);" aria-label="open help popup" style={{cursor: "hand"}} className={fa_cls_list} aria-expanded="false" aria-haspopup="true" tabindex="0" data-toggle="dropdown">{l}</a></li>);
        });

        return (

            <div className="svr-gal-contentWrapper">                 
                 <div className="svr-amenity-content" >
                    <ul className="svr-amenity-list-full " >
                        
                       {sv_ams_li}
                     
                  </ul>
              </div>
              
    
            </div>
        )
    }
    renderOld(){
        const sv_ams_li = this.props.legends.map((l, k)=>{
            return (
                <div className="board-legend-item flex-center-vertical" key={k}>
                    {/* <div className="flex-center"> */}
                        <div className={`legend-${l.color}`}></div>
                        <div className="filter-legend">{l.name}</div>
                    {/* </div> */}
                </div>
                )
            });
        return (
            <div className="board-legend row">
                {sv_ams_li}
            </div>
        );
    }
}

export default TerrainAmenities;